// Agents settings page — manage all 4 agent types via tabs.

import { useState } from "react";
import type { JSX } from "react";
import { Shell } from "../components/Shell.js";
import { AgentTab } from "./AgentsPage.tabs.js";

const TABS = [
  { key: "delivery_agent",           label: "Delivery Agents" },
  { key: "sample_collection_agent",  label: "Sample Collection" },
  { key: "nutritionist_agent",       label: "Nutritionists" },
  { key: "property_manager",         label: "Property Managers" },
] as const;

export function AgentsPage(): JSX.Element {
  const [activeTab, setActiveTab] = useState<string>(TABS[0].key);

  return (
    <Shell>
      <div className="max-w-7xl mx-auto px-4 py-6 space-y-4">
        <h1 className="text-xl font-semibold text-slate-900">Agents</h1>
        <div className="flex gap-1 bg-slate-100 p-1 rounded-lg w-fit">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setActiveTab(t.key)}
              className={`text-xs font-medium px-3 py-1.5 rounded-md transition-colors ${
                activeTab === t.key
                  ? "bg-white text-slate-900 shadow-sm"
                  : "text-slate-500 hover:text-slate-700"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
        <AgentTab agentType={activeTab} />
      </div>
    </Shell>
  );
}
